import { useEffect, useState } from 'react';

const useScrolledToBottomOfPdf = (selector) => {
  const [hasScrolled, setHasScrolled] = useState(false);
  const [singlePageinMobile, setSinglePageinMobile] = useState(false);
  const isMobileView = window.innerWidth < 768;
  useEffect(() => {
    const iframe = document.querySelector(`${selector} iframe`);
    const setStateIfAtBottom = () => {
      const vc = iframe?.contentWindow?.document?.body?.querySelector('#viewerContainer');
      if (vc && vc.scrollTop >= vc.scrollHeight - vc.offsetHeight - 50) {
        setHasScrolled(true);
      }
    };
    const doCleanup = () => {
      const vc = iframe?.contentWindow?.document?.body?.querySelector('#viewerContainer');
      if (vc) {
        vc.removeEventListener('scroll', setStateIfAtBottom);
        iframe?.contentWindow?.removeEventListener('pagesloaded', setStateIfAtBottom, true);
      }
    };

    if (iframe) {
      iframe.onload = () => {
        const vc = iframe?.contentWindow?.document?.body?.querySelector('#viewerContainer');
        if (vc) {
          const { PDFViewerApplication } = iframe.contentWindow;

          const checkPdfLoaded = () => {
            if (PDFViewerApplication.pdfDocument) {
              const { numPages } = PDFViewerApplication.pdfDocument;

              if (numPages === 1) {
                if (isMobileView) {
                  setSinglePageinMobile(true);
                }
              }
            } else {
              setTimeout(checkPdfLoaded, 500);
            }
          };

          checkPdfLoaded();
          vc.addEventListener('scroll', setStateIfAtBottom);
          iframe?.contentWindow?.addEventListener('pagesloaded', setStateIfAtBottom, true);
        } else {
          setHasScrolled(true);
        }
      };
      iframe.onunload = doCleanup;
    } else {
      setHasScrolled(true);
    }

    if (singlePageinMobile) {
      setHasScrolled(true);
    }

    return doCleanup;
  }, [selector, hasScrolled, singlePageinMobile]);

  return hasScrolled;
};

export default useScrolledToBottomOfPdf;
